import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { RequestStrategyEnum, UserApi, type GetStatusResponse } from '@shared/api';

interface UseStatusStore {
  loading: boolean;
  data?: GetStatusResponse | null;
  error: string | null;
  getStatus: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useStatusStore = create<UseStatusStore>((set) => ({
  loading: false,
  data: undefined,
  error: null,

  getStatus: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await UserApi.getStatus(signal);
      set({ data: result || null, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: undefined, loading: false, error: null }),
}));
